// constants
import { ContactUsSubmissionsActionTypes } from './constants';

export interface ContactUsSubmissionsActionType {
    type:
    | ContactUsSubmissionsActionTypes.API_RESPONSE_SUCCESS
    | ContactUsSubmissionsActionTypes.API_RESPONSE_ERROR
    | ContactUsSubmissionsActionTypes.CONTACT_US_SUBMISSIONS_LIST
    payload: {} | string;
}

interface FiltersData {
    sortBy: string,
    limit: number,
    page: number,
    search: string
};

interface ResponseData {
    actionType: string,
    responseData: any,
}


// common success
export const contactUsSubmissionsApiResponseSuccess = ({ actionType, responseData }: ResponseData): ContactUsSubmissionsActionType => ({
    type: ContactUsSubmissionsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, responseData },
});
// common error
export const contactUsSubmissionsApiResponseError = (actionType: string, error: string): ContactUsSubmissionsActionType => ({
    type: ContactUsSubmissionsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const contactUsSubmissionsList = ({
    sortBy,
    limit,
    page,
    search,
}: FiltersData): ContactUsSubmissionsActionType => ({
    type: ContactUsSubmissionsActionTypes.CONTACT_US_SUBMISSIONS_LIST,
    payload: {
        search,
        sortBy,
        limit,
        page,
    },
});




